import { module } from 'modujs';
import LocomotiveScroll from 'locomotive-scroll';
import { html } from '../utils/environment'
import { queryClosestParent } from '../utils/html'
import { lazyLoadImage } from '../utils/image';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.scroll = new LocomotiveScroll({
            el: this.el,
            smooth: false,
            getDirection: true,
        });

        this.scroll.on('call', (func,way,obj,id) => {
            // Using modularJS
            this.call(func[0],{way,obj},func[1],func[2]);
        });

        this.scroll.on('scroll', (instance) => {
            window.scrollObj = instance

            if(typeof instance.currentElements['value-humans'] === 'object') {
                let progress = instance.currentElements['value-humans'].progress;
                this.call('progress',progress,'Rotate','value-humans');
            }

            if(typeof instance.currentElements['value-curiosity'] === 'object') {
                let progress = instance.currentElements['value-curiosity'].progress;
                this.call('progress',progress,'Rotate','value-curiosity');
            }

            if(typeof instance.currentElements['value-confident'] === 'object') {
                let progress = instance.currentElements['value-confident'].progress;
                this.call('progress',progress,'Rotate','value-confident');
            }

            if(typeof instance.currentElements['value-feel-good'] === 'object') {
                let progress = instance.currentElements['value-feel-good'].progress;
                this.call('progress',progress,'Rotate','value-feel-good');
            }

            if(typeof instance.currentElements['value-contact'] === 'object') {
                let progress = instance.currentElements['value-contact'].progress;
                this.call('progress',progress,'Rotate','value-contact');
            }

            if(typeof instance.currentElements['rotate-img'] === 'object') {
                let progress = instance.currentElements['rotate-img'].progress;
                this.call('progress',progress,'Rotate','rotate-img');
            }

            if(typeof instance.currentElements['logoAnimation'] === 'object') {
                let progress = instance.currentElements['logoAnimation'];
                this.call('onScroll', [progress, instance], 'LogoAnimation');
            }
        })

        // Callback to update nav banner
        this.onUpdate = () => {
            if(html.scrollTop > 80) {
                html.classList.add('has-scrolled');
            } else {
                html.classList.remove('has-scrolled');
            }

            requestAnimationFrame(this.onUpdate)
        }
        this.onUpdate()

        if (window.location.hash) {
            // Get the hash without the '#' and find the matching element
            const id = window.location.hash.slice(1, window.location.hash.length);
            let target = document.getElementById(id);

            // If found, scroll to the element
            if (target) {
                this.stop()
                this.start()

                requestAnimationFrame(() => {
                    this.scrollTo([target, -90])
                })
            }
        }
    }

    toggleLazy(args) {
        lazyLoadImage(args.obj.el, null, () => {
            // callback
        })
    }

    scrollTo(param) {
        if (this.scroll && this.scroll.scrollTo) {
            this.scroll.scrollTo(param[0], {offset: param[1]})
        }
    }

    update() {
        if(this.scroll && this.scroll.update) this.scroll.update();
    }

    stop() {
        if(this.scroll && this.scroll.stop) this.scroll.stop();
    }

    start() {
        if(this.scroll && this.scroll.start) this.scroll.start();
    }

    destroy() {
        cancelAnimationFrame(this.update);
        html.classList.remove('has-scrolled');
        this.scroll.destroy();
    }
}
